export default "__VITE_ASSET__me2TIjAJ__"